import { useState } from "react";

import OptionsForm from "./OptionsForm";

import { ArrowLeft, ArrowRight } from "react-feather";

// ** Reactstrap Imports
import { Button } from "reactstrap";

const QuestionItem = ({ questionData, multiChoice, stepper, j ,sumVote,handelOptionSelect}) => {

  return (
    <div >
      <h3  style={{display:"flex",overflowWrap:"break-word",marginBottom:"15px"}}>{questionData.ques_text}</h3>

      <div
        className="d-flex p-1 border"
        style={{ display: "flex", flexDirection: "column" }}
      >
        
        <OptionsForm
          multiChoice={multiChoice}
          j={j}
          progresbarChart={sumVote>0}
          sumVote={sumVote}
          optionsData={questionData.quetionsOption}
          handelOptionSelect={handelOptionSelect}
  
        />
      
      </div>
    </div>
  );
};

export default QuestionItem;
